<mat-toolbar color="primary" class="action-toolbar">
    <button mat-icon-button (click)="returnToParent()" matTooltip="Back">
        <mat-icon color="primary">arrow_back_ios</mat-icon>
    </button>
    <h3>{{ patient | patientHeading:'Procedure Codes' }}</h3>
    <div>
        <button mat-icon-button color="warn" *ngIf="selectedProcedureCodes.length" (click)="deleteCodingGroup()"
            matTooltip="Delete Coding">
            <mat-icon color="warn">delete</mat-icon>
        </button>
        <button mat-icon-button [disabled]="form.invalid" (click)="saveBilling()" matTooltip="Save Coding">
            <mat-icon [color]="form.invalid ? '' : 'primary'">save</mat-icon>
        </button>
    </div>
</mat-toolbar>
<div id="top"></div>

<div class="details-container">
    <form [formGroup]="form">
        <mat-card>
            <mat-form-field appearance="outline">
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="dateDatePicker" formControlName="date" placeholder="DD/MM/YYYY"
                    [max]="todayDate">
                <mat-datepicker-toggle matSuffix [for]="dateDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #dateDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Coding Bundle</mat-label>
                <mat-select formControlName="codingBundle" (selectionChange)="selectCodingBundle($event)">
                    <mat-option *ngFor="let bundle of codingBundles" [value]="bundle">
                        {{ bundle.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="toggle-container">
                <mat-slide-toggle formControlName="paidCash" color="primary"
                    (change)="toggleCodeStatus($event, 'up-front')">Paid Up Front</mat-slide-toggle>
                <mat-slide-toggle formControlName="noCharge" color="primary"
                    (change)="toggleCodeStatus($event, 'no-charge')" class="m-l-5">Pro Bono</mat-slide-toggle>
            </div>

            <!-- Provider Selection Dropdown -->
            <mat-form-field appearance="outline" *ngIf="showProviderSelection">
                <mat-label>{{ isEditingMode ? 'Provider (Codes will be linked to selected provider)' : 'Provider' }}</mat-label>
                <mat-select formControlName="providerId" (selectionChange)="onProviderSelectionChange($event.value)">
                    <mat-option *ngFor="let user of groupUsers" [value]="user.userId">
                        {{user.title}} {{user.name}} {{user.surname}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <app-procedure-code-selector [initialCodes]="selectedProcedureCodes"
                [onChipDblClick]="openEditDialog.bind(this)"
                hintText="Double click or tap and hold a specific code to edit it's details"
                (codesChanged)="onProcedureCodesChanged($event)" (codeDeleted)="onProcedureCodeDeleted($event)"
                [patient]="patient" #procedureCodeSelector></app-procedure-code-selector>

        </mat-card>
    </form>

</div>

<ng-template #addCodeDialog>
    <h1 mat-dialog-title>Code Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20 column-fields">
            <mat-form-field appearance="outline">
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="codeDatePicker" [(ngModel)]="editingCode.date" placeholder="DD/MM/YYYY"
                    [max]="todayDate">
                <mat-datepicker-toggle matSuffix [for]="codeDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #codeDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Code</mat-label>
                <input matInput [(ngModel)]="editingCode.code" type="text" required disabled>
            </mat-form-field>
            <mat-form-field appearance="outline" *ngIf="shouldShowTimeFields()">
                <mat-label>Start Time</mat-label>
                <input matInput [(ngModel)]="editingCode.startTime" [ngxTimepicker]="startTimePicker" [format]="24"
                    required>
                <ngx-material-timepicker #startTimePicker [theme]="darkTheme" [appendToInput]="true"
                    [preventOverlayClick]="true"></ngx-material-timepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" *ngIf="shouldShowTimeFields()">
                <mat-label>End Time</mat-label>
                <input matInput [(ngModel)]="editingCode.endTime" [ngxTimepicker]="endTimePicker" [format]="24"
                    required>
                <ngx-material-timepicker #endTimePicker [theme]="darkTheme" [appendToInput]="true"
                    [preventOverlayClick]="true"></ngx-material-timepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" *ngIf="shouldShowAssistantFields()">
                <mat-label>Assistant Name</mat-label>
                <input matInput [(ngModel)]="editingCode.assistantName" (ngModelChange)="filterAssistants($event)"
                    [matAutocomplete]="assistantAuto">
                <mat-autocomplete #assistantAuto="matAutocomplete"
                    (optionSelected)="onAssistantSelected($event.option.value)">
                    <mat-option *ngFor="let assistant of filteredAssistants" [value]="assistant.name">
                        {{ assistant.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field appearance="outline" *ngIf="shouldShowAssistantFields()">
                <mat-label>Practice Number</mat-label>
                <input matInput [(ngModel)]="editingCode.assistantPracticeNumber">
            </mat-form-field>
            <mat-form-field appearance="outline" *ngIf="editingCode.code === '0018'">
                <mat-label>Weight</mat-label>
                <input matInput [(ngModel)]="editingCode.weight" (input)="calculateBMI()" required>
                <span matSuffix>&nbsp; kg&nbsp;</span>
            </mat-form-field>
            <mat-form-field appearance="outline" *ngIf="editingCode.code === '0018'">
                <mat-label>Height</mat-label>
                <input matInput [(ngModel)]="editingCode.height" (input)="calculateBMI()" required>
                <span matSuffix>&nbsp; cm&nbsp;</span>
            </mat-form-field>
            <p *ngIf="editingCode.BMI">Calculated BMI: {{editingCode.BMI}}</p>
            <!-- Provider Selection for Individual Code -->
            <mat-form-field appearance="outline" *ngIf="groupUsers.length > 1">
                <mat-label>Provider (for this code)</mat-label>
                <mat-select [(ngModel)]="editingCode.providerId" (selectionChange)="onEditDialogProviderChange($event.value)">
                    <mat-option *ngFor="let user of groupUsers" [value]="user.userId">
                        {{user.title}} {{user.name}} {{user.surname}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="toggle-container">
                <mat-slide-toggle [(ngModel)]="editingCode.paidCash" color="primary"
                    (change)="toggleIndividualCodeStatus(editingCode, 'up-front')">Paid Up Front</mat-slide-toggle>
                <mat-slide-toggle [(ngModel)]="editingCode.noCharge" color="primary"
                    (change)="toggleIndividualCodeStatus(editingCode, 'no-charge')" class="m-l-5">No
                    Charge</mat-slide-toggle>
            </div>
        </div>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="saveCodeEdit()">Save</button>
    </div>

</ng-template>